import { Border, Color, Padding } from '@/GlobalStyles';
import { useAuthContext } from '@/components/Auth/AuthContext';
import Menu from '@/components/Menu/Menu';
import MenuDivider from '@/components/Menu/MenuDivider';
import MenuItem from '@/components/Menu/MenuItem';
import { useDeleteChirurgienMutation } from '@/data/data';
import { useApolloClient } from '@apollo/client';
import { useAsyncStorage } from '@react-native-async-storage/async-storage';
import * as Auth from 'aws-amplify/auth';
import { router } from 'expo-router';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Linking, StyleSheet, View } from 'react-native';
import { Icon } from 'react-native-paper';
import { useUserContext } from '../Auth/UserContext';

const ProfileMenu = () => {
  const client = useApolloClient();
  const authUser = useAuthContext();
  const { user } = useUserContext();
  const asyncStorage = useAsyncStorage('apollo-cache-persist');
  const { t } = useTranslation();
  const [deleteChirurgien] = useDeleteChirurgienMutation();

  return (
    <Menu
      isSimplePressable
      anchor={
        <View style={styles.profileContainer}>
          <Icon size={32} source={'menu'} color={Color.blanc} />
        </View>
      }
      posX={-17}
    >
      <MenuItem
        key="menu_patient"
        title={t('Patients')}
        onPress={() => {
          router.push('/patients');
        }}
      />
      <MenuItem
        key="menu_profil"
        title={t('Mon profil')}
        onPress={() => {
          router.push('/profil');
        }}
      />
      <MenuDivider key={'divider1'} />
      {authUser.payload && authUser.payload['cognito:groups'].indexOf('admin') > -1 ? (
        <Fragment key={'menu_frag'}>
          <MenuItem
            key="menu_laboratoires"
            title={t('Laboratoires')}
            onPress={() => {
              router.push('/laboratoires');
            }}
          />
          <MenuItem
            key="menu_implants"
            title={t('Implants')}
            onPress={() => {
              router.push('/implants');
            }}
          />
          <MenuItem
            key="menu_statistiques"
            title={t('Statistiques')}
            onPress={() => {
              router.push('/statistiques');
            }}
          />
          <MenuItem
            key="menu_parametres"
            title={t('Paramètres')}
            onPress={() => {
              router.push('/parametres');
            }}
          />
        </Fragment>
      ) : null}
      <MenuItem
        key="menu_aide_contextuelle"
        title={t('Aide contextuelle')}
        onPress={() => {
          router.push('/parametres/aide-contextuelle');
        }}
      />
      <MenuItem
        key="menu_documents"
        title={'Documents'}
        onPress={() => {
          Linking.openURL(
            'https://iolmatch-front.netlify.app/assets/questionnaire-habitudes-visuelles-biometrie.pdf'
          );
        }}
      />
      <MenuItem
        key="menu_documents_classification"
        title={'Classifications'}
        onPress={() => {
          Linking.openURL('https://iolmatch-front.netlify.app/assets/Classifications.pdf');
        }}
      />
      <MenuDivider key={'divider2'} />
      <MenuItem
        key="menu_profile_deconnexion"
        title={t('Déconnexion')}
        textStyle={{ color: Color.error }}
        onPress={async () => {
          await client.clearStore();
          await asyncStorage.removeItem();
          await Auth.signOut();
        }}
      />
      <MenuDivider key={'divider3'} />
      <MenuItem
        key="menu_profile_desinscription"
        title={t('Désinscription')}
        textStyle={{ color: Color.error }}
        onPress={() => {
          Alert.alert(
            'Attention',
            'Cette action est irréversible, êtes vous sur de vouloir vous désinscrire et de supprimer toutes vos données patients ?',
            [
              {
                text: 'Annuler',
                style: 'cancel',
                isPreferred: true,
                onPress: () => {},
              },
              {
                text: 'Confirmer',
                onPress: async () => {
                  await deleteChirurgien({
                    variables: {
                      id: user?.id,
                    },
                    fetchPolicy: 'network-only',
                  });
                  await Auth.deleteUser();
                },
              },
            ]
          );
        }}
      />
    </Menu>
  );
};

export default ProfileMenu;

const styles = StyleSheet.create({
  profileContainer: {
    borderRadius: Border.br_sm,
    width: 48,
    padding: Padding.p_7xs,
    justifyContent: 'center',
    height: 48,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: Color.colorGray_100,
    borderStyle: 'solid',
    alignItems: 'center',
    flexDirection: 'row',
    marginHorizontal: Padding.p_lg,
  },
});
